var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"border-gray_d4d px-12px h-50px",class:_vm.column.theme === 'no-border' ? 'border-b border-t' : 'border',attrs:{"role":"columnheader","width":_vm.column.width}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }